export const L10N = {
  ACTION_HOTEL_VERSE: { id: 'core.action.hotel_verse' },
  LABEL_HOTEL_VERSE: { id: 'core.label.hotel_verse' },
};
